module.exports = __webpack_public_path__ + "media/images/home/tom_brady-0924c4a3c559f04363324e139e32717a.jpg";